//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Header, MobileMenu } from '@cmp/common';
import { BenefitSection } from '../welcome/client/landing/components';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { AboutBackground, AboutBackgroundResponsive } from '@cmp/images';
//------------------------------------------------------------------------------
// Helpers ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
    };

    this.handleToggle = this.handleToggle.bind(this);
  }

  textContainer(
    title,
    subtitleComponent,
    subtitle,
    footerComponent,
    className
  ) {
    const componentClasses = classNames(styles.TextContainer, {
      [className]: className,
    });

    return (
      <div className={componentClasses} key={title}>
        <h3 className={styles.Title}>{title}</h3>
        {subtitleComponent}
        {subtitle && <span className={styles.Subtitle}>{subtitle}</span>}
        {footerComponent}
      </div>
    );
  }

  sectionsComponent(sections) {
    let components = [];
    sections.forEach((x) =>
      components.push(
        this.textContainer(
          x.title,
          x.subtitleComponent,
          x.subtitle,
          null,
          styles.Section
        )
      )
    );

    return <>{components}</>;
  }

  handleToggle() {
    this.setState((state) => ({ toggle: !state.toggle }));
  }

  render() {
    const componentClasses = classNames(styles.About);
    const { toggle } = this.state;
    const { handleToggle } = this;
    const { t } = this.props;

    return (
      <div className={componentClasses}>
        <Helmet>
          <title>{t('about_About')}</title>
        </Helmet>

        <Header toggle={toggle} onToggle={handleToggle} />
        {toggle ? (
          <div className={styles.ContentMobile}>
            <MobileMenu />
          </div>
        ) : (
          <>
            <AboutBackground className={styles.Banner} />
            <AboutBackgroundResponsive className={styles.BannerResponsive} />
            <div className={styles.Container}>
              <h3 className={styles.PageTitle}>{t('about_IntroText')}</h3>
              {/* Intro */}
              {this.textContainer(null, null, t('about_IntroSubtitle'))}
              <BenefitSection screenName="About" />
            </div>
          </>
        )}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(About);
